import React, { useState } from 'react';
import CompanyName from '../../commonComponents/CompanyName';
import useAppContext from '../../../hooks/useAppContext';
import { AppContextType } from '../../../context/AppContext';
import { DateType } from '../../../static/types/commonTypes/dateType';
import { CompanyNameType } from '../../../static/types/commonTypes/companyNameType';
import { RegistrationReferenceType } from '../../../static/types/commonTypes/registrationReferenceType';
import { NotaryContactType } from '../../../static/types/commonTypes/notaryContactType';
import { IndividualWithFamilySituationType } from '../../../static/types/commonTypes/individualWithFamilySituationType';
import { MariageContractType } from '../../../static/types/commonTypes/mariageContractType';
import { AddressType } from '../../../static/types/commonTypes/addressType';
import RegistrationReference from '../../commonComponents/RegistrationReference';
import NotaryContact from '../../commonComponents/NotaryContact';
import IndividualWithFamilySituation from '../../commonComponents/IndividualWithFamilySituation';
import MariageContract from '../../commonComponents/MariageContract';
import ReducedIndividualPerson from '../../commonComponents/ReducedIndividualPerson';
import Address from '../../commonComponents/Address';
import DateComponent from '../../commonComponents/DateComponent';
import { ReducedIndividualPersonType } from '../../../static/types/commonTypes/reducedIndividualPersonType';
import { SlArrowLeft, SlArrowRight } from "react-icons/sl";
import { FaUpload } from 'react-icons/fa';
import { GoArrowRight } from 'react-icons/go';
import { formatObjectText } from '../../../utils/functions/formatObjectText';

interface AnnonceProps {
    txtAnnonce: string;
    updateActiveIndex: (index: number) => void;
    updateTxtAnnonce: (newTxt: string) => void;
    updateDenomination: (newTxt: string) => void;
    societyType: string | string[];
    societeSelected: string;
    updatesocieteSelected: (newTxt: string) => void;

}

const DeclarationInsaisissabilite: React.FC<AnnonceProps> = ({
    txtAnnonce,
    updateTxtAnnonce,
    updateActiveIndex,
    updateDenomination,
    societyType,
    updatesocieteSelected
}) => {

    const {
        companyName, setCompanyName,
        companyNameValidity, setCompanyNameValidity,
        companyNameChecked, setCompanyNameChecked,

        registrationReference, setRegistrationReference,
        registrationReferenceValidity, setRegistrationReferenceValidity,
        registrationReferenceChecked, setRegistrationReferenceChecked,

        notaryContact, setNotaryContact,
        notaryContactValidity, setNotaryContactValidity,
        notaryContactChecked, setNotaryContactChecked,

        applicant, setApplicant,
        applicantValidity, setApplicantValidity,
        applicantChecked, setApplicantChecked,

        mariageContract, setMariageContract,

        reducedIndividualPerson, setReducedIndividualPerson,
        reducedIndividualPersonValidity, setReducedIndividualPersonValidity,
        reducedIndividualPersonChecked, setReducedIndividualPersonChecked,

        residentialAddress, setResidentialAddress,
        residentialAddressValidity, setResidentialAddressValidity,
        residentialAddressChecked, setResidentialAddressChecked,

        mainResidenceAddress, setMainResidenceAddress,
        mainResidenceAddressValidity, setMainResidenceAddressValidity,
        mainResidenceAddressChecked, setMainResidenceAddressChecked,

        deathDate, setDeathDate

    } = useAppContext() as AppContextType

    const [activeTab, setActiveTab] = useState<string>('companyName');
    const [visitedTabs, setVisitedTabs] = useState(['companyName']);
    const [submissive, setSubmissive] = useState(false)

    const societyTypeOptions = Array.isArray(societyType) ? societyType : [societyType];

    const handleSubmit = (e: React.FormEvent) => {

        e.preventDefault();

        if (validate()) {

            const registrationReferenceText = `Au terme d'un acte authentique du ${registrationReference.acteDate} reçu par Maître ${notaryContact.notaryName}, notaire associé, membre de la SCP ${notaryContact.scpName}, sis ${notaryContact.address}${notaryContact.additionalAddress ? `${notaryContact.additionalAddress}` : ''} ${notaryContact.postalCode} ${notaryContact.city}, publié et enregistré le ${registrationReference.registrationDate}, au bureau des hypothèques de ${registrationReference.mortgage}.`

            const applicantText = (): string => {

                let res = ``

                let applicantInfo = `${applicant.civility === 'Monsieur' ? 'M.' : 'Mme'} ${applicant.lastName} ${applicant.firstName}`

                let spouseInfo = `${reducedIndividualPerson.civility === 'Monsieur' ? 'M.' : 'Mme'} ${reducedIndividualPerson.lastName} ${reducedIndividualPerson.firstName}`

                if (applicant.familySituation === "Célibataire") {
                    res = applicantInfo
                }
                else if (applicant.familySituation === "Pacsé") {
                    res = `${applicantInfo} ${applicant.civility === 'Monsieur' ? 'pacsé' : 'pacsée'} à ${spouseInfo}${applicant.eventDate ? ` depuis le ${applicant.eventDate}` : ''}${applicant.eventPlace ? ` à ${applicant.eventPlace}` : ''}, demeurant ensemble au`
                }
                else if (applicant.familySituation === "Marié") {
                    if (applicant.maritalRegime === 'Communauté de biens réduite aux acquêts') {
                        res = `${applicantInfo} ${applicant.civility === 'Monsieur' ? 'époux' : 'épouse'} de ${spouseInfo}, mariés sous le régime de la ${applicant.maritalRegime.toLowerCase()}${applicant.eventDate ? ` du ${applicant.eventDate}` : ''}${applicant.eventPlace ? ` à ${applicant.eventPlace}` : ''}, demeurant ensemble au`
                    }
                    else {
                        res = `${applicantInfo} ${applicant.civility === 'Monsieur' ? 'époux' : 'épouse'} de ${spouseInfo}, mariés sous le régime de la ${applicant.maritalRegime.toLowerCase()} ${mariageContractText}, demeurant ensemble au`
                    }
                }
                else if (applicant.familySituation === "Divorcé") {
                    res = `${applicantInfo} ${applicant.civility === 'Monsieur' ? 'divorcé' : 'divorcée'} de ${spouseInfo}${applicant.eventPlace ? ` , suivant jugement rendu par le Tribunal de Grande Instance de ${applicant.eventPlace}` : ''}${applicant.eventDate ? ` du ${applicant.eventDate}` : ''}, demeurant au`
                }
                else if (applicant.familySituation === "Veuf(ve)") {
                    res = `${applicantInfo} ${applicant.civility === 'Monsieur' ? 'veuf' : 'veuve'} de ${spouseInfo} ${deathDate.date ? `${reducedIndividualPerson.civility === 'Monsieur' ? 'décédé' : 'décédée'} le ${deathDate.date}` : ''}, demeurant au`
                }

                return res
            }

            const mariageContractText = `aux termes du contrat de mariage ${mariageContract.editor ? `reçu par Maitre ${mariageContract.editor}` : ''}${mariageContract.editPlace ? `, notaire à ${mariageContract.editPlace}` : ''}${mariageContract.editDate ? `, le ${mariageContract.editDate}` : ''} ${(applicant.eventPlace || applicant.eventDate) ? 'préalable au mariage' : ''}${applicant.eventDate ? ` du ${applicant.eventDate}` : ''}${applicant.eventPlace ? ` à ${applicant.eventPlace}` : ''}`

            const mainResidenceAddressText = `a, en application de l'article L.526-1 du Code de Commerce, déclaré insaisissables ses droits sur l'immeuble où est fixée sa résidence principale, située au ${mainResidenceAddress.address}${mainResidenceAddress.additionalAddress ? `${mainResidenceAddress.additionalAddress}` : ''} ${mainResidenceAddress.postalCode} ${mainResidenceAddress.city}. Ladite propriété constituant un bien de communauté.`

            const residentialAddressText = `${residentialAddress.address}${residentialAddress.additionalAddress ? `${residentialAddress.additionalAddress}` : ''} ${residentialAddress.postalCode} ${residentialAddress.city}`

            const tempText = `${registrationReferenceText},
${applicantText()} ${residentialAddressText}, ${mainResidenceAddressText}`

            const formattedText = formatObjectText(tempText);
            updateTxtAnnonce(formattedText);
            updateDenomination(companyName.companyName)
            setSubmissive(true);
        }
    };

    const validate = () => {
        if (!companyNameValidity) setActiveTab('companyName')
        else if (!registrationReferenceValidity) setActiveTab('registrationReference')
        else if (!notaryContactValidity) setActiveTab('notaryContact')
        else if (!applicantValidity) setActiveTab('applicant')
        else if (showSpouse && !reducedIndividualPersonValidity) setActiveTab('spouse')
        else if (!residentialAddressValidity) setActiveTab('residentialAddress')
        else if (!mainResidenceAddressValidity) setActiveTab('mainResidenceValidity')

        const spouseValidity = showSpouse ? reducedIndividualPersonValidity : true

        return companyNameValidity && registrationReferenceValidity && notaryContactValidity && applicantValidity && spouseValidity && residentialAddressValidity && mainResidenceAddressValidity
    }

    const switchTab = (tab: string) => {
setActiveTab(tab);
    };

    const handleNext = () => {
        if (activeTab === 'companyName') {
            setCompanyNameChecked(true)
            if (companyNameValidity) switchTab(getNextTab('companyName'))
        }
        else if (activeTab === 'registrationReference') {
            setRegistrationReferenceChecked(true)
            if (registrationReferenceValidity) switchTab(getNextTab('registrationReference'))
        }
        else if (activeTab === 'notaryContact') {
            setNotaryContactChecked(true)
            if (notaryContactValidity) switchTab(getNextTab('notaryContact'))
        }
        else if (activeTab === 'applicant') {
            setApplicantChecked(true)
            if (applicantValidity) switchTab(getNextTab('applicant'))
        }
        else if (activeTab === 'mariageContract') {
            switchTab(getNextTab('mariageContract'))
        }
        else if (showSpouse && activeTab === 'spouse') {
            setReducedIndividualPersonChecked(true)
            if (reducedIndividualPersonValidity) switchTab(getNextTab('spouse'))
        }
        else if (activeTab === 'residentialAddress') {
            setResidentialAddressChecked(true)
            if (residentialAddressValidity) switchTab(getNextTab('residentialAddress'))
        }
        else if (activeTab === 'mainResidenceAddress') {
            setMainResidenceAddressChecked(true)
            if (residentialAddressValidity) setSubmissive(true)
        }
    };

    const handlePrevious = () => {
        switchTab(getPreviousTab(activeTab));
        setSubmissive(false)
    };

    const getNextTab = (currentTab: string) => {
        if (currentTab === 'companyName') return 'registrationReference';
        else if (currentTab === 'registrationReference') return 'notaryContact';
        else if (currentTab === 'notaryContact') return 'applicant';
        else if (currentTab === 'applicant') {
            if (showMariageContract) return 'mariageContract'
            else if (showSpouse) return 'spouse'
            else return 'residentialAddress'
        }
        else if (currentTab === 'mariageContract') return 'spouse'
        else if (currentTab === 'spouse') return 'residentialAddress'
        else if (currentTab === 'residentialAddress') return 'mainResidenceAddress'
        else return currentTab
    };

    const getPreviousTab = (currentTab: string) => {
        if (currentTab === 'registrationReference') return 'companyName';
        else if (currentTab === 'notaryContact') return 'registrationReference';
        else if (currentTab === 'applicant') return 'notaryContact';
        else if (currentTab === 'mariageContract') return 'applicant';
        else if (currentTab === 'spouse') {
            if (showMariageContract) return 'mariageContract';
            else return 'applicant';
        }
        else if (currentTab === 'residentialAddress') {
            if (showSpouse) return 'spouse'
            else if (showMariageContract) return 'mariageContract'
            else return 'applicant'
        }
        else if (currentTab === 'mainResidenceAddress') return 'residentialAddress'
        else return currentTab
    };

    const goToSupportPresse = () => { updateActiveIndex(2); }

    const updateCompanyName = (data: Partial<CompanyNameType>) => setCompanyName({ ...companyName, ...data });
    const updateRegistrationReference = (data: Partial<RegistrationReferenceType>) => setRegistrationReference({ ...registrationReference, ...data });
    const updateNotaryContact = (data: Partial<NotaryContactType>) => setNotaryContact({ ...notaryContact, ...data });
    const updateApplicant = (partialData: Partial<IndividualWithFamilySituationType>) => setApplicant({ ...applicant, ...partialData })
    const updateMariageContract = (data: Partial<MariageContractType>) => setMariageContract({ ...mariageContract, ...data });
    const updateSpouse = (data: Partial<ReducedIndividualPersonType>) => setReducedIndividualPerson({ ...reducedIndividualPerson, ...data });
    const updateResidentialAddress = (data: Partial<AddressType>) => setResidentialAddress({ ...residentialAddress, ...data });
    const updateMainResidenceAddress = (data: Partial<AddressType>) => setMainResidenceAddress({ ...mainResidenceAddress, ...data });
    const updateDeathDate = (data: Partial<DateType>) => setDeathDate({ ...deathDate, ...data });

    const showMariageContract = applicant.familySituation === "Marié" && applicant.maritalRegime !== "Communauté de biens réduite aux acquêts"
    const showSpouse = applicant.familySituation !== "Célibataire"

    const tabs = [
  { key: 'companyName', label: 'Raison Sociale' },
  { key: 'registrationReference', label: "Références de l'enregistrement" },
  { key: 'notaryContact', label: 'Coordonnées du notaire, nom et adresse de la SCP' },
  { key: 'applicant', label: 'Le demandeur' },
];

if (showMariageContract) {
  tabs.push({ key: 'mariageContract', label: 'Contrat de mariage' });
}

if (showSpouse) {
  tabs.push({ key: 'spouse', label: 'Conjoint' });
}

tabs.push(
  { key: 'residentialAddress', label: "Adresse d'habitation" },
  { key: 'mainResidenceAddress', label: 'Adresse de la résidence principale' }
);

    return (
        <>
                <div className="container my-3">
                <ul className="nav nav-underline">
                    {tabs
                    .filter((t) => t.key === activeTab) 
                    .map((t) => (
                        <li className="nav-item" key={t.key}>
                        <a
                            href={`#${t.key}`}
                            className={`nav-link active`} 
                        >
                            {t.label}
                        </a>
                        </li>
                    ))}
                    </ul>
                </div>

            <form onSubmit={handleSubmit}>
                {
                    activeTab === 'companyName' &&
                    <div>
                        <span className='mb-2'>
                            Indiquer la raison sociale de la société ou la dénomination du Cabinet de Notaire annonceur ou l'état civil de la personne concernée par l'annonce, en optionnel vous pouvez ajouter une référence client.
                        </span>
                        <div className="tab-content">
                            <CompanyName
                                changeCompanyName={updateCompanyName}
                                checked={companyNameChecked}
                                companyName={companyName}
                                onValidationChange={(isValid: boolean) => setCompanyNameValidity(isValid)}
                                showClientReference={true}
                            />
                        </div>
                    </div>
                }

                {
                    activeTab === 'registrationReference' &&
                    <RegistrationReference
                        changeRegistrationReference={updateRegistrationReference}
                        checked={registrationReferenceChecked}
                        onValidationChange={(isValid: boolean) => setRegistrationReferenceValidity(isValid)}
                        registrationReference={registrationReference}
                    />
                }

                {
                    activeTab === 'notaryContact' &&
                    <NotaryContact
                        changeNotaryContact={updateNotaryContact}
                        checked={notaryContactChecked}
                        notaryContact={notaryContact}
                        onValidationChange={(isValid: boolean) => setNotaryContactValidity(isValid)}
                    />
                }

                {
                    activeTab === 'applicant' &&
                    <IndividualWithFamilySituation
                        changeIndividual={updateApplicant}
                        checked={applicantChecked}
                        individual={applicant}
                        onValidationChange={(isValid: boolean) => setApplicantValidity(isValid)}
                    />
                }

                {
                    activeTab === 'mariageContract' &&
                    showMariageContract &&
                    <MariageContract
                        changeMariageContract={updateMariageContract}
                        mariageContract={mariageContract}
                    />
                }

                {
                    activeTab === 'spouse' &&
                    showSpouse &&
                    <>
                        <ReducedIndividualPerson
                            changeReducedIndividualPerson={updateSpouse}
                            checked={reducedIndividualPersonChecked}
                            onValidationChange={(isValid: boolean) => setReducedIndividualPersonValidity(isValid)}
                            reducedIndividualPerson={reducedIndividualPerson}
                        />
                        {
                            applicant.familySituation === "Veuf(ve)" &&
                            <DateComponent
                                changeDate={updateDeathDate}
                                date={deathDate}
                                draftFieldName = 'deathDate'
                                dateLabel='Date du décès'
                                required={false}
                            />
                        }
                    </>
                }

                {
                    activeTab === 'residentialAddress' &&
                    <Address
                        address={residentialAddress}
                        draftFieldName = 'residentialAddress'
                        changeAddress={updateResidentialAddress}
                        checked={residentialAddressChecked}
                        onValidationChange={(isValid: boolean) => setResidentialAddressValidity(isValid)}
                    />
                }

                {
                    activeTab === 'mainResidenceAddress' &&
                    <Address
                        address={mainResidenceAddress}
                        draftFieldName = 'mainResidenceAddress'
                        changeAddress={updateMainResidenceAddress}
                        checked={mainResidenceAddressChecked}
                        onValidationChange={(isValid: boolean) => setMainResidenceAddressValidity(isValid)}
                    />
                }

                {
                    submissive &&
                    activeTab === 'mainResidenceAddress' &&
                    <div className="mt-4">
                        <h4>Texte de l'annonce:</h4>
                        <textarea
                            className="form-control"
                            rows={5}
                            value={txtAnnonce}
                            disabled
                        />
                    </div>
                }

                <div className="button-container">
                    <div className="d-flex gap-2">
                        {
                            activeTab !== 'companyName' && (
                                <button color="#F4A261"
                                    className="btn-add"
                                    type="button"
                                    onClick={handlePrevious} >
                                    <SlArrowLeft className="icon" style={{ marginRight: '10px', fontSize: '20px' }} />
                                    Modifier mon annonce
                                </button>
                            )}

                        {
                            activeTab === 'mainResidenceAddress' && (
                                <button type="submit"
                                    onClick={handleNext}>
                                    Mettre à jour mon annonce
                                    <FaUpload className="icon" style={{ marginLeft: '15px', fontSize: '20px' }} />
                                </button>
                            )}

                        {
                            activeTab !== 'mainResidenceAddress' && (
                                <button color="#F4A261"
                                    className="btn-add"
                                    type="button"
                                    onClick={handleNext} >
                                    Suivant
                                    <SlArrowRight className="icon" style={{ marginLeft: '10px', fontSize: '20px' }} />
                                </button>
                            )}

                        {
                            submissive && activeTab === 'mainResidenceAddress' && (
                                <button color="#F4A261"
                                    className="btn-add"
                                    type="button"
                                    onClick={goToSupportPresse} >
                                    Sélection du support
                                    <GoArrowRight className="icon" style={{ marginLeft: '10px', fontSize: '20px' }} />
                                </button>
                            )}
                    </div>
                </div>
            </form>
        </>
    );
};

export default DeclarationInsaisissabilite;